<template>
    <div>
        <div class="back" @click="goBack">&lt; 返 回</div>
        <div class="common-style" v-if="!noData">
            <h3>{{ title }}</h3>
            <div v-for="(item, index) in guidanceStudyList" :key="index">
                <ul class="guidanceStudy-list">
                    <li @click="handle(ele,index)" v-for="(ele,index) in item.list" :key="ele.id" :class="index==current?'current':''">
                        <div class="avatar">
                            <a-avatar :size="60" :src="ele.avatar" />
                        </div>
                        <div>{{ ele.studentName }}</div>
                        <div class="posStatus" :class="changeColor(ele.status)">
                            <span v-if="ele.status <= 1">未提交</span>
                            <span v-else>{{ ele.statusName }}</span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- 分页 -->
            <!-- <div style="padding:20px;" v-if="paginShow">
        <a-pagination
          size="small"
          :total="rowCount"
          :showTotal="total => `总 ${total} 份`"
          :pageSize.sync="pagination.pageSize"
          v-model="pagination.page"
          @change="onChange"
        />
      </div>-->
        </div>
        <div style="position:relative">
            <div v-if="noData" class="noData">
                <p>
                    <img src="../../assets/images/noData.png" alt />
                </p>
            </div>
            <!-- 刷新 -->
            <div class="loada" v-if="loadingList">
                <a-spin />
            </div>
        </div>
        <!-- 弹框 -->
        <a-modal v-model="visible" :footer="null" :closable="false" :bodyStyle="{ padding: 0 }" width="650px" centered>
            <a-carousel arrows :dots="false">
                <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
                    <a-icon type="left-circle" />
                </div>
                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                    <a-icon type="right-circle" />
                </div>
                <div v-for="(item1, index1) in picList" :key="index1">
                    <img :src="item1" style="width:650px;height:300px" @click="preview(item1)" />
                </div>
            </a-carousel>
        </a-modal>

        <!-- 预览 -->
        <a-modal v-model="previewModal" :footer="null" :closable="false" :bodyStyle="{ padding: 0 }" width="850px" centered>
            <img :src="imgPreview" />
        </a-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            visible: false,
            previewModal: false,
            imgPreview: "",
            dxid: "",
            classid: "",
            guidanceStudyList: [],
            title: "",
            noData: true,
            loadingList: true,
            picList: [],
            current: -1,
            changeColor: function (val) {
                // console.log(val);
                if (val == 0) {
                    return "blue";
                } else if (val == 1) {
                    return "blue";
                } else if (val == 2) {
                    return "red";
                } else if (val == 3) {
                    return "orange";
                }
            }
            // rowCount: "",
            // pagination: {
            //   page: 1,
            //   pageSize: 8
            // },
            // paginShow: false  // 分页
        };
    },

    methods: {
        // 分页
        // onChange(page, pageSize) {
        //   this.pagination.page = page;
        //   this.pagination.pageSize = pageSize;
        //   this.getguidanceStudyList();
        // },

        goBack () {
            this.$router.go(-1);
        },

        async handle (item, index) {
            this.current = index;
            console.log(item);
            const { data: res } = await this.$http.get(
                `v1/learnonly/dx/getStudentDxPic`,
                {
                    params: {
                        studentid: item.studentId,
                        dxid: item.dxId
                        // studentid: 241,
                        // dxid: 42
                    }
                }
            );
            console.log(res);
            const imgList = res.data.split(",");
            console.log(imgList);

            // if (res.code == 200) {
            //   if (imgList.length != 0) {
            //     this.visible = true;
            //     this.picList = imgList;
            //   } else {
            //     this.visible = false;
            //     this.$message.warning("该学生暂无导学案截图数据");
            //   }
            // }
            if (res.code == 200 && res.data != "") {
                this.visible = true;
                this.picList = imgList;
            } else {
                this.visible = false;
                this.$message.warning("该学生暂无导学案截图数据");
            }
        },

        async getguidanceStudyList () {
            // var classids = [];
            // this.classid.forEach(item => {
            //   classids.push(item.classId);
            // });

            const { data: res } = await this.$http.get(
                `v1/learnonly/dx/teacherDxList`,
                {
                    params: {
                        dxid: this.dxid,
                        classids: this.classid
                    }
                }
            );
            console.log(res);
            if (res.code == 200) {
                this.guidanceStudyList = res.data;
                this.title = res.data[0].list[0].title;
                this.loadingList = false;
                this.noData = false;
                // this.rowCount = res.data.paginator.totalCount;
                // this.$nextTick(() => {
                //   this.paginShow = true;
                // });
            } else {
                this.noData = true;
                this.loadingList = false;
                // this.paginShow = false;
            }
        },

        // 预览
        preview (img) {
            this.previewModal = true;
            this.imgPreview = img;
        }
    },

    created () {
        this.dxid = this.$route.query.dxid;
        this.classid = this.$route.query.classid;
    },

    mounted () {
        this.getguidanceStudyList();
    }
};
</script>

<style scoped>
.common-style h3 {
    text-align: center;
    font-size: 24px;
    padding: 20px 0;
}

.common-style h4 {
    padding: 0 20px;
    font-size: 20px;
    margin: 0;
}

.guidanceStudy-list {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    padding: 1%;
}

.guidanceStudy-list li {
    display: flex;
    position: relative;
    justify-content: start;
    align-items: center;
    width: 18%;
    margin: 1%;
    border: 1px solid #ccc;
    cursor: pointer;
    overflow: hidden;
    border-radius: 5px;
    transition: all 0.3s;
    padding: 5px 0;
}

.guidanceStudy-list li:hover {
    border-color: rgba(0, 0, 0, 0.09);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transform: translate(0, -5px);
}

.guidanceStudy-list .current {
    /* transform: translate(0, -5px); */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.avatar {
    margin: 10px 20px;
}

.posStatus {
    position: absolute;
    /* top: 25%; */
    right: -22px;
    height: 80%;
    text-align: center;
    padding: 6px 24px 6px 5px;
    border-radius: 15%;
    letter-spacing: 3px;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
}

.blue {
    background-color: #40a9ff;
    color: #fff;
}

.gray {
    background-color: #dcdedb;
    /* color: #fff; */
}

.orange {
    background-color: #e6a23c;
    color: #fff;
}

.red {
    background-color: #f56c6c;
    color: #fff;
}

/* 82cffd
f5a664
fa8f05
dcdedb */

/* ----------------  */
.ant-modal >>> .ant-modal-body {
    padding: 0;
}

.ant-carousel >>> .slick-slide {
    text-align: center;
    height: 300px;
    line-height: 300px;
    background: #fff;
    overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #000;
    background-color: rgba(31, 45, 61, 0.01);
    opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
    display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
    color: #fff;
}
/* ----------------- */

/* 刷新 */

.loada {
    position: absolute;
    overflow: hidden;
    top: 120%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    outline: 0;
    background: rgb(255, 255, 255, 0.3);
}
/* =================================== */
</style>
